import DotsVertical from '../../../SharedComponents/Svg/DotsVertical';

export default function OptionsMenuItem() {
  return (
    <button className=' text-gray-500  p-1 rounded transition duration-300 ease-in-out'>
      <DotsVertical className='w-5 h-5' />
    </button>
  );
}
